import {createContext,useState} from 'react'
import {v4 as uuidv4} from 'uuid';
import feedbackdata from '../../data/feedbackData';

const FeedbackContext=createContext()


export const FeedbackProvider=({children})=>{
    const [feedback,setFeedback]=useState(feedbackdata)
    const [feedbackEdit,setFeedbackEdit]=useState({
      item:{},
      edit:false
    })
    //deleting feedback
    const deleteFeedback=(id)=>{
        setFeedback(feedback.filter((item)=>item.id!==id))
      }
      //adding feedback
      const addFeedback=(newFeedback)=>{
        newFeedback.id=uuidv4()
        setFeedback([newFeedback,...feedback])
         setFeedbackEdit({
            item:{},
            edit:false
          })
        console.log(newFeedback);
    
      }
      //item to be updated
      const editFeedback=(item)=>{
        setFeedbackEdit({
          item,
          edit:true
        })
      }
      //update data
      const updateFeedback=(id,upItem)=>{
          setFeedback(feedback.map((item)=>item.id===id?{...item,...upItem}:item))
          setFeedbackEdit({
            item:{},
            edit:false
          })
      }
    return <FeedbackContext.Provider value={{
        feedback,
        deleteFeedback,
        addFeedback,
        editFeedback,
        updateFeedback,
        feedbackEdit
    }}>
        {children}
    </FeedbackContext.Provider>
}

export default FeedbackContext
